import React from "react";

const CseSem6MDU = () => {
  return (
    <>
      <div style={{ backgroundColor: "#Dbe6ea" }}>
        <h1 class="mb-1">
          SEMESTER 6 <br />
          Select Your Subject
          <div class="spinner-grow text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </h1>
      </div>
      <div class="accordion" id="accordionExample">
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingOne">
            <button
              class="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              Ajava
            </button>
          </h2>
          <div
            id="collapseOne"
            class="accordion-collapse collapse show"
            aria-labelledby="headingOne"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/file/d/1A3jPpV-umtKzam1rxGyU4tRWnk0yTAx5/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2021
                </button>
              </a>
              <br />
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingTwo">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              Computer Networks
            </button>
          </h2>
          <div
            id="collapseTwo"
            class="accordion-collapse collapse"
            aria-labelledby="headingTwo"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/file/d/1bdB-mmQcY1n9v3HbY1207rWJbUj5FpaD/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2015
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1BWvBjGuGVasUkS4dsT3iCEJk1-P_F84e/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2016
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1nevkwe0U0iUaeDuO1ZVaCfcvOPFJB20G/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2017
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1DYpiCF5s4NSKbZYBzjLwuEP6CKlahgOk/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2018
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1lz44aWVBV-SfcuolxX2hueZDvs0DlJZM/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2019
                </button>
              </a>
              <br />
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingThree">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              Analysis Design and Algorithms
            </button>
          </h2>
          <div
            id="collapseThree"
            class="accordion-collapse collapse"
            aria-labelledby="headingThree"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/file/d/1mVEJ0BxTv2Qq1rGqpmLhafDmi8gFt3KA/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2013
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/17ptGC9ARj7-tI8jNttxPHC-KqzEJPAwq/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2014
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1CDgjVp-PC3Zp0pft9IJ5abHa9JAoxIUa/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2016
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1GSpbPI0g5SWJYD9o5XjB88NsrrYQpUYs/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2017
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/13SYC4UfM2AiPixevJBGIfCC9tO9-oAJ6/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2018
                </button>
              </a>
              <br />
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingFour">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFour"
              aria-expanded="false"
              aria-controls="collapseFour"
            >
              Digital System Design
            </button>
          </h2>
          <div
            id="collapseFour"
            class="accordion-collapse collapse"
            aria-labelledby="headingFour"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/file/d/114iq2LuEIlPiAf1GF8slNp-YFit-r4mI/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2017
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1TbXGkPaKeRmulSWi1TNVJ-F7KlQ7SYHn/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2018
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1C-la-yXFf5vtNixB5vVLSi14FM7cBVMB/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2019
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1nlyEsuBWJmwTbBY9gAtTWyd-DsD9K9-K/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2020
                </button>
              </a>
              <br />
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingFive">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFive"
              aria-expanded="false"
              aria-controls="collapseFive"
            >
              Intelligent System
            </button>
          </h2>
          <div
            id="collapseFive"
            class="accordion-collapse collapse"
            aria-labelledby="headingFive"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/file/d/1AGqIufMk2QOs0MG5E06ft0mgs_svldzX/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2016
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/15ekaH7nyxWnBEzvguK-56CCphq0sIYQT/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2017
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1-s-XGY5D0dPHB1M3sKztGW_98MKuQQ93/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2018
                </button>
              </a>
              <br />
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingSix">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseSix"
              aria-expanded="false"
              aria-controls="collapseSix"
            >
              System Program and System Administration
            </button>
          </h2>
          <div
            id="collapseSix"
            class="accordion-collapse collapse show"
            aria-labelledby="headingSix"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/file/d/1RxjmpBMArDSJhCWTFO6TBT4u9FXJR4aY/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2013
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/14eK9AoplUo8gXbHzJLszLQzuZwn67GB9/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2014
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1MAzlu4bTOZeA80EdlF2ppcpTK2ArLSXN/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2015
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1ShAF0dXJzZR1W3qRDnvbGB1fpmhtpx5B/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2016
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1KVq-S_JtK4Q-cqmjEByq4mS_jBh3zKWK/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2017
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1RaepXvlEsCPUL5eOLukPR0SDLu-918wc/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2018
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/14g3pFRm6a5CIxsvQIrTnBzYIlyw3Yuo9/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2019
                </button>
              </a>
              <br />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CseSem6MDU;
